import React, { useEffect, useState } from "react";
import "./header.scss";
import { NavLink, Link } from "react-router-dom";

import RoomCard from "../room/RoomCard";
import EditDeletebtn from "../admin/EditDeletebtn";

const RoomHeader = (props) => {
  const [category, setCategory] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_API_URL}/category/data/city/${props.props}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        return setCategory(data), setLoading(false);
      });

    fetch(`${process.env.REACT_APP_API_URL}/home/data/city/${props.props}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setData(data);
      });
  }, []);

  const found = (data) => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/home/data/${data._id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setData(data), setLoading(false);
      });
  };

  const showLoading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-6 mt-5 mb-2">
          {category.map((data) => {
            return (
              <button
                key={data._id}
                className="btn btn-outline-primary mr-3 mb-2"
                onClick={(area) => found(data)}
              >
                {data.name}
              </button>
            );
          })}
        </div>
      </div>
      {showLoading()}
      <div className="row mt-3">
        {/* {data.length > 0 ? ( */}
        <>
          {data
            .map((home) => {
              return (
                <div className="col-sm-3 align-self-center" key={home._id}>
                  <Link
                    to={`/room/${home._id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <RoomCard room={home} />
                  </Link>
                  <EditDeletebtn roomID={home._id} />
                </div>
              );
            })
            .reverse()}
        </>
        {/* ) : (
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            Room not found in this Area
          </div>
        )} */}
      </div>
    </div>
  );
};

export default RoomHeader;
